<template>
  <div class='notice'>
    <div class="notice-content" v-if="noticeList">
      <div class="announcements">
        <i class="iconfont icon">&#xe652;</i>
        通知公告
      </div>
      <div class="noticeCentent">
        <marquee id="marquee" direction="left" @mouseover="stop()" @mouseout="start()" scrollamount="6" style="padding: 0px 0pt;" height="40px">
          <p class="content" v-for="(item) of noticeList.slice(0,5)" :key="item.id" @click="toDetail(item.article_id)">
            <strong style="font-size: 14px">· </strong>{{item.title}}
          </p>
        </marquee>
      </div>
    </div>
  </div>
</template>

<script>
import { orgId, requestUrl } from '../common/constant'
import axios from 'axios'

export default {
  name: 'Notice',
  data () {
    return {
      noticeList: []
    }
  },
  mounted () {
    this.getNoticeList()
  },
  methods: {
    start () {
      const marquee = document.getElementById('marquee')
      marquee.start()
    },
    stop () {
      const marquee = document.getElementById('marquee')
      marquee.stop()
    },
    async getNoticeList () {
      const result = await axios.get(`${requestUrl}/notice/${orgId}`)
      this.noticeList = result.data
    },
    toDetail (articleId) {
      this.$router.push(`content/${articleId}`)
    }
  }
}
</script>

<style scoped>
  .notice {
    width: 100%;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, .2);
  }
  .notice-content {
    width: 1190px;
    margin: 0 auto;
    height: 40px;
  }
    .announcements {
      width: 120px;
      line-height: 40px;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      cursor: pointer;
      float: left;
      color: #f10215;
    }
    .icon {
      color: #f10215;
    }
    .noticeCentent {
      width: 1070px;
      height: 40px;
      overflow: hidden;
      cursor: pointer;
    }
  .content {
    line-height: 40px;
    display: inline-block;
    padding-left: 50px;
    font-size: 18px;
    z-index: 1000;
  }
  .content:hover {
    color: #f10215;
  }
</style>
